import { render, staticRenderFns } from "./ProductKeyFeatures.vue?vue&type=template&id=3b239e58"
import script from "./ProductKeyFeatures.vue?vue&type=script&lang=js"
export * from "./ProductKeyFeatures.vue?vue&type=script&lang=js"
import style0 from "./ProductKeyFeatures.vue?vue&type=style&index=0&id=3b239e58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports